import { Injectable } from "@angular/core";

@Injectable()
export class LoaderService {
  loading: boolean = false;

  set isLoading(loading: boolean) {
    this.loading = loading;
  }
  get isLoading(): boolean {
    return this.loading;
  }
}
